import { render, staticRenderFns } from "./ezrichDeposit.vue?vue&type=template&id=a79d4bf6&scoped=true&"
import script from "./ezrichDeposit.vue?vue&type=script&lang=js&"
export * from "./ezrichDeposit.vue?vue&type=script&lang=js&"
import style0 from "./ezrichDeposit.vue?vue&type=style&index=0&id=a79d4bf6&prod&lang=scss&scoped=true&"
import style1 from "./ezrichDeposit.vue?vue&type=style&index=1&id=a79d4bf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79d4bf6",
  null
  
)

export default component.exports